import Menu from "./components/Menu";
import { getIsKnown } from "../user/selectors";
import { connect } from "react-redux";
import { getHabits, getIsHabitsLoaded } from "../habits/selectors";
import { getIsAuthenticated } from "../user/selectors";
import type { StateProps, DispatchProps, OwnProps } from "./components/Menu";

const mapStateToProps = (state, ownProps) => {
  const habits = getHabits(state);
  const isHabitsLoaded = getIsHabitsLoaded(state);
  const isLoggedIn = getIsKnown(state) ? getIsAuthenticated(state) : null;
  return { ...ownProps, habits, isLoggedIn, isHabitsLoaded };
};

const mapDispatchToProps = {};
export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(Menu);
